/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { type ContentStackPencilBanner } from '../../interface';
import { Text, View } from '@az/starc-ui';
import { CMSLink } from '../CMSLink/CMSLink';
import styles from './CMSPencilBanner.module.scss';

export const CMSPencilBanner = ({ content }: { content: ContentStackPencilBanner }) => {
  const {
    uid,
    header,
    header_text_color,
    body,
    body_text_color,
    link,
    layout,
    background_color,
    text_align,
  } = content;
  const isInlineLayout = layout === 'Inline';

  return (
    <CMSLink to={link ?? ''}>
      <View key={uid}>
        <View
          direction={isInlineLayout ? 'row' : 'column'}
          className={styles.banner}
          attributes={{ style: { backgroundColor: background_color?.hex } }}
          justify={isInlineLayout ? text_align : undefined}
        >
          {header && (
            <View.Item>
              <Text
                align={text_align}
                className={styles.overrideMainBody}
                variant="main-body"
                weight="bold"
                attributes={{ style: { ...{ color: header_text_color?.hex } } }}
              >
                {header}
              </Text>
            </View.Item>
          )}
          <View.Item gapBefore={layout === 'Inline' ? 3 : 1}>
            <View
              className={styles.defaultBodyText}
              attributes={{
                style: { color: body_text_color?.hex, textAlign: text_align },
                dangerouslySetInnerHTML: { __html: body },
              }}
            />
          </View.Item>
        </View>
      </View>
    </CMSLink>
  );
};
